"use client";

import { cn } from "@/lib/utils";
import Link from "@app/_components/Link";
import useTracking from "@features/tracking/hooks/useTracking";
import { TrackedCustomProduct } from "@features/tracking/utils";
import type { ComponentProps } from "react";

export default function ProductCardLink({
  product,
  pageData,
  className,
  ...props
}: ComponentProps<typeof Link> & {
  product?: TrackedCustomProduct;
  pageData?: { id?: string; title?: string };
}) {
  const { trackProduct } = useTracking();
  return (
    <Link
      onClick={() => product && trackProduct(product, pageData)}
      className={cn("no-underline", className)}
      {...props}
    />
  );
}

ProductCardLink.displayName = "ProductCardLink";
